import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { isPhone, isWeb } from '@helpers';

import TouchableElement from '@components/common/touchableElement';
import EditableLine from '@components/common/editableLine';

import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import Button from '@styles/buttons';
import { modalFieldBg } from '@v2/pages/common/constants/base.constants';

export default ({ C, data, updateDataObj, validateUserAction, goBack }) => {
  const submitDisabled = !data.userName || !data.password;
  const lines = [
    {
      key: 'userName',
      placeholder: 'User name',
      noArrow: true,
      isLable: false,
    },
    {
      key: 'password',
      placeholder: 'Password',
      noArrow: true,
      isLable: false,
      secure: true,
    },
  ];

  const titles = {
    CredentialForConnection: 'Machine Credentials',
    CredentialForConnectionAndFileTransfer: 'Machine Credentials',
    CredentialForFileTransfer: 'Machine File Credentials',
  };

  const descriptions = {
    CredentialForConnection: 'CREDENTIALS TO ACCESS MACHINE',
    CredentialForConnectionAndFileTransfer: 'CREDENTIALS TO ACCESS MACHINE',
    CredentialForFileTransfer: 'CREDENTIALS TO ACCESS MACHINE FILES',
  };

  return (
    <View style={{ paddingBottom: scale(15), paddingHorizontal: isPhone ? 0 : scale(15) }}>
      <View>
        <View
          style={{
            width: '100%',
            zIndex: 1000,
            height: scale(58),
          }}
        >
          <View style={{ position: 'absolute', zIndex: 1000, left: 0 }}>
            <TouchableElement
              onPress={() => {
                goBack();
                updateDataObj({
                  machineCredentials: null,
                  userName: '',
                  password: '',
                  credentialsErrorMessage: '',
                });
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15), paddingHorizontal: isPhone ? scale(15) : 0, flexDirection: 'row' }]}>
                  <View style={{ marginTop: scale(2) }}>
                    <Svg icon="chevronLeft" width={scale(11)} height={scale(17)} color="Link / Light / Primary" />
                  </View>
                  <Text style={[{ color: C(pressHoverColor('System/Light/Blue')), marginLeft: scale(7) }, font.Body]}>{i18n.t('Back')}</Text>
                </View>
              )}
            </TouchableElement>
          </View>
          <View style={{ position: 'absolute', zIndex: 1000, right: 0 }}>
            <TouchableElement
              onPress={async () => {
                if (submitDisabled) {
                  return;
                }
                let typeExist = false;
                const machineCredentials = data.machineCredentials ? [...data.machineCredentials] : [];
                machineCredentials.forEach((i) => {
                  if (i.machineCredentialType == data.credentialTypeRequired) {
                    typeExist = true;
                    i.userName = data.userName;
                    i.password = data.password;
                    if (i.allowToContinueIfInvalid) {
                      i.allowToContinueIfInvalid = false;
                    }
                  }
                });
                if (!typeExist) {
                  machineCredentials.push({
                    machineCredentialType: data.credentialTypeRequired,
                    userName: data.userName,
                    password: data.password,
                  });
                }
                await validateUserAction({
                  ...data,
                  machineCredentials,
                });
              }}
            >
              {({ boxStyle, pressHoverColor }) => (
                <View style={[boxStyle, { padding: scale(15) }]}>
                  <Text style={[{ color: C(pressHoverColor(submitDisabled ? 'Label/Light/Quinary' : 'Link/Light/Primary')) }, font.Headline]}>
                    {i18n.t('Login')}
                  </Text>
                </View>
              )}
            </TouchableElement>
          </View>
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>
            {i18n.t(titles[data.credentialTypeRequired] || 'Login Information')}
          </Text>
        </View>
      </View>
      <View style={{ marginTop: scale(28), paddingHorizontal: scale(isPhone ? 15 : 30) }}>
        <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>
          {i18n.t(descriptions[data.credentialTypeRequired] || 'LOGIN INFORMATION OF MACHINE')}
        </Text>
      </View>
      <View style={{ marginTop: scale(5), paddingHorizontal: isPhone ? 0 : scale(15) }}>
        {lines.map((item, index) => (
          <EditableLine
            {...{
              key: item.key,
              item: {
                ...item,
                value: data[item.key],
                onChange: (v) => {
                  updateDataObj({
                    [item.key]: v,
                  });
                },
              },
              bg: modalFieldBg,
              array: lines,
              index,
              C,
              bottomBorderBox: isPhone,
              topBorderBox: isPhone,
              topBorder: index !== 0,
              roundTop: !isPhone && index === 0,
              roundBottom: !isPhone && index === lines.length - 1,
            }}
          />
        ))}
      </View>
      {data.credentialTypeRequired === 'CredentialForFileTransfer' && (
        <View style={{ width: '100%', alignItems: 'center', marginTop: scale(20), paddingHorizontal: scale(15) }}>
          {data.allowedToContinueWithWarning && (
            <View>
              <Button
                {...{
                  variant: 'L',
                  type: 'Only Text Link',
                  onPress: async () => {
                    let typeExist = false;
                    const machineCredentials = data.machineCredentials ? [...data.machineCredentials] : [];
                    machineCredentials.forEach((i) => {
                      if (i.machineCredentialType == data.credentialTypeRequired) {
                        typeExist = true;
                        i.userName = data.userName;
                        i.password = data.password;
                        i.allowToContinueIfInvalid = true;
                      }
                    });
                    if (!typeExist) {
                      machineCredentials.push({
                        machineCredentialType: data.credentialTypeRequired,
                        userName: data.userName,
                        password: data.password,
                        allowToContinueIfInvalid: true,
                      });
                    }
                    await validateUserAction({
                      ...data,
                      machineCredentials,
                    });
                  },
                  borderRadius: scale(10),
                }}
              >
                {i18n.t('Skip')}
              </Button>
            </View>
          )}
          <Text style={[{ color: C('Label/Light/Primary'), textAlign: 'center', marginTop: scale(20) }, font.Body]}>
            {i18n.t('If you don’t enter valid credentials, NC files on the CNC machine cannot be read.')}
          </Text>
        </View>
      )}
    </View>
  );
};
